import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';
import { image, SanityImage } from './image';

export const SanitySocialProofRatingStars = z.object({
  _type: z.literal('socialProofRatingStars'),
  _key: z.string(),
  logo: SanityImage,
  rating: z.number().min(1).max(5),
  text: SanityBasicText,
});

export type SanitySocialProofRatingStars = z.infer<
  typeof SanitySocialProofRatingStars
>;

export const SanitySocialProof = z
  .array(SanitySocialProofRatingStars)
  // Remove max(1) when we allow multiple social proofs animating between them
  .max(1)
  .optional()
  .nullable();

export type SanitySocialProof = z.infer<typeof SanitySocialProof>;

export const socialProofRatingStars = groq`{
  _type,
  _key,
  "logo": logo ${image},
  rating,
  "text": text[] ${basicText}
}`;

export const socialProof = groq`[] {
  _type,
  _type == "socialProofRatingStars" => ${socialProofRatingStars}
}`;
